import interpolateStringToTemplate from './interpolate-string-to-template';

const parseTemplate = (template, context) =>
  JSON.parse(interpolateStringToTemplate(JSON.stringify(template), context));

export default parseTemplate;
